import { Routes } from '@angular/router';
import { RankingComponent } from './ranking.component';
import { AuthGuardService } from '../guards/auth-guard.service';

export const rankingRoutes: Routes = [
  {
    path: 'ranking',
    component: RankingComponent,
    canActivate: [ AuthGuardService ],
  }
];



// WEBPACK FOOTER //
// ./src/app/ranking/ranking.routes.ts